export const iframeMutations = {
    setIframeLoaded(state, isLoaded = true) {
        state.iframe = document.querySelector("#iframe");
        state.iframeLoaded = isLoaded;
    },
};
